import { FunctionComponent } from "react";
import { Icon } from "../Icon";
import useDevice from "../../utils/hooks/useDevice";

type Props = {
  openModal: () => void;
};

const HomeVideoComponent: FunctionComponent<Props> = ({ openModal }) => {
  const { width } = useDevice();

  return (
    <section className="video_container">
      <img
        src="/assets/images/rtabak_video.png"
        alt="Imagen de video"
        className={`video_screen_mobile ${width > 900 && `video_screen`}`}
      />
      {width > 900 ? (
        <Icon iconName="rtabak_grey_icon" className="video_icon" />
      ) : null}
      <div className={width > 900 ? "video_cta" : "video_cta_mobile"}>
        <div className={`video_info_mobile ${width > 900 && `video_info`}`}>
          <p>NUESTRO TALLER</p>
          <h3>Proceso de fabricación con tecnología avanzada conocénos!</h3>
        </div>
        <div className={`video_play_mobile ${width > 900 && `video_play`}`}>
          <button onClick={openModal}>
            <Icon iconName="video_play" />
          </button>
          <p>REPRODUCIR VIDEO</p>
        </div>
      </div>
      {width < 900 ? (
        <Icon iconName="rtabak_grey_icon" className="video_icon_mobile" />
      ) : null}
    </section>
  );
};

export default HomeVideoComponent;
